export default "__VITE_ASSET__BI9Cc5l1__"